import { render, staticRenderFns } from "./userInfoMotor.vue?vue&type=template&id=0d24c8ee&"
import script from "./userInfoMotor.vue?vue&type=script&lang=ts&"
export * from "./userInfoMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports